import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DocumentGenerateConfigService } from './document-generate-config.service';

// formatea montos (money) o stock con los decimales de la compañía; impuro para reflejar el config al cargar
@Pipe({ name: 'dgNumber', standalone: true, pure: false })
export class DgNumberPipe implements PipeTransform {
  constructor(
    private config: DocumentGenerateConfigService,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  transform(value: number | null | undefined, kind: 'money' | 'stock' = 'money'): string {
    const decimals = kind === 'stock' ? this.config.stockDisplayDecimals : this.config.moneyDecimals;
    return formatNumber(Number(value) || 0, this.locale, `1.${decimals}-${decimals}`);
  }
}
